import { render, staticRenderFns } from "./coupondetail.vue?vue&type=template&id=006ac827&scoped=true&"
import script from "./coupondetail.vue?vue&type=script&lang=js&"
export * from "./coupondetail.vue?vue&type=script&lang=js&"
import style0 from "./coupondetail.vue?vue&type=style&index=0&id=006ac827&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "006ac827",
  null
  
)

export default component.exports